import { useState, type JSX } from 'react';
import { FOLDER_PURPOSES, FOLDER_PURPOSE_LABELS, folderPurposeOf, type FolderPurpose } from '@/lib/folderPurpose';
import type { Folder } from '../api/types';

export function CheckFolderPicker({ folders, value, onChange, purpose, onPurposeChange, disabled }: {
  folders: Folder[]; value: string[]; onChange: (ids: string[]) => void;
  purpose: FolderPurpose | ''; onPurposeChange: (purpose: FolderPurpose | '') => void; disabled?: boolean;
}): JSX.Element {
  const [search, setSearch] = useState('');
  const visible = folders.filter((f) => (!purpose || folderPurposeOf(f.purpose) === purpose) && f.name.toLowerCase().includes(search.toLowerCase()));
  const all = visible.length > 0 && visible.every((f) => value.includes(f.publicId));
  return <div className="space-y-2">
    <div className="flex flex-wrap gap-2">
      <label className="flex-1 space-y-1 text-sm">Folder type
        <select aria-label="Folder type to check" className="block w-full rounded-md border bg-background px-3 py-2" disabled={disabled} value={purpose}
          onChange={(e) => { onPurposeChange(e.target.value as FolderPurpose | ''); onChange([]); }}>
          <option value="">All types</option>
          {FOLDER_PURPOSES.map((p) => <option key={p} value={p}>{FOLDER_PURPOSE_LABELS[p]}</option>)}
        </select>
      </label>
      <label className="flex-1 space-y-1 text-sm">Find folders
        <input aria-label="Find folders to check" className="block w-full rounded-md border bg-background px-3 py-2" placeholder="Search folders…" value={search} disabled={disabled} onChange={(e) => setSearch(e.target.value)} />
      </label>
    </div>
    <div className="max-h-56 overflow-auto rounded-md border">
      <table className="w-full text-left text-sm" aria-label="Folders to check">
        <thead className="sticky top-0 bg-background"><tr className="border-b">
          <th className="p-2"><input type="checkbox" aria-label="Select all matching folders" checked={all} disabled={disabled || !visible.length}
            onChange={() => onChange(all ? value.filter((id) => !visible.some((f) => f.publicId === id)) : [...new Set([...value, ...visible.map((f) => f.publicId)])])} /></th>
          <th className="p-2 font-medium">Folder</th><th className="p-2 font-medium">Type</th>
        </tr></thead>
        <tbody>{visible.map((f) => <tr key={f.publicId} className="border-b last:border-0">
          <td className="p-2"><input type="checkbox" aria-label={`Select folder ${f.name}`} checked={value.includes(f.publicId)} disabled={disabled}
            onChange={() => onChange(value.includes(f.publicId) ? value.filter((id) => id !== f.publicId) : [...value, f.publicId])} /></td>
          <td className="p-2">{f.name}</td><td className="p-2 text-muted-foreground">{FOLDER_PURPOSE_LABELS[folderPurposeOf(f.purpose)]}</td>
        </tr>)}</tbody>
      </table>
      {visible.length === 0 && <p className="p-3 text-sm text-muted-foreground">No folders match.</p>}
    </div>
    <p className="text-xs text-muted-foreground">{value.length} folders selected · {visible.length} shown</p>
  </div>;
}
